import Interact from "../services/interact";
import zxcvbn from 'zxcvbn';
/**
 * @var service.ready
 * @var service.banners
 */
const Controller =  ['$scope', '$rootScope', '$http', '$modules', '$device', '$templateRequest', '$cookies', '$google', '$hotJar', '$objects', function($scope, $rootScope, $http, $modules, $device, $templateRequest, $cookies, $google, $hotJar, $objects) {

    $rootScope.searchMobileVisible = false;

    $rootScope.showLoginPopup = false;
    $rootScope.loadLoginPopup = false;

    $scope.closeLoginPopup = function () {
        $rootScope.showLoginPopup = false;
    }

    /**
     * If user interacted with the device we show the footer banners
     * @type {boolean}
     */
    $scope.interacted = false;
    Interact.event(() => {
        $scope.interacted = true;
        $scope.$apply();
    });

        let ins = document.querySelector('ins.advertisement-box');

        $scope.blocked = typeof ins === "undefined" || (ins.offsetHeight + ins.offsetWidth ) === 0;

        $scope.modules = $modules;
        $scope.modules.add('byg');
        $scope.modules.add('chrome');
        $scope.modules.add('cookies');
        $scope.chromeInterstitialHref = null;

        /**
         * This handles autocomplete modules
         */

        $rootScope.searchGlobal = {};
        $rootScope.searchActors = {};
        $rootScope.searchPerformers = {};
        $rootScope.searchChannels = {};

        /**
         * Current language
         */

        $scope.language = window.variables.language;

        /**
         * Get alternate languages
         */
        $scope.alternates = window.variables.alternates;



        let http_build_query = function (o) {
            let s = [];
            for ( let p in o ) if ( o.hasOwnProperty(p)) {
                s.push(encodeURIComponent(p) + "=" + encodeURIComponent(o[p]));
            }
            return s.join("&");
        };

        // let elem = document.createElement('p');
        // elem.setAttribute('id', 'QTjUHnLtvlqc');
        // elem.classList.add('ads');
        // elem.classList.add('super-ad');
        // elem.classList.add('viagra');
        // elem.classList.add('video_ad');
        // elem.classList.add('banner');
        // elem.classList.add('ad');
        // elem.textContent = '.';
        // document.body.appendChild(elem);
        // setTimeout(function () {
        //     $scope.blocked = ((elem.offsetWidth + elem.offsetHeight) === 0 || elem.offsetParent === null);
        //     document.body.dataset.blocked = $scope.blocked ? 'true' : 'false';
        //     elem.parentNode.removeChild(elem);
        //     $scope.$apply();
        // }, 50 );

            // console.log("XXX ");
            // console.log($scope.blocked);
            // if ( $scope.blocked === false ) {
            //     window.exo99HL3903jjdxtrnLoad = true;
            // }
            // console.log(elem.offsetParent === null);

            // if(document.getElementById('QTjUHnLtvlqc')){
            // Set data blocked on the body





        //
        //
        // let detector = function () {
        //     return {
        //         label: window.innerWidth <= 768 ? 'mobile' : 'desktop',
        //         desktop: window.innerWidth > 768,
        //         mobile: window.innerWidth <= 768,
        //         width: window.innerWidth,
        //         height: window.innerHeight,
        //         ios: (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream),
        //         android: (/android/.test(navigator.userAgent)),
        //         orientation: window.innerWidth < window.innerHeight ? 'portrait' : 'landscape',
        //         touch: (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch)) || (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
        //     }
        // };

        let footerModules = () => {
            $scope.footerInformation = !$scope.device.mobile;
            $scope.footerAccount = !$scope.device.mobile;
            $scope.footerPartner = !$scope.device.mobile;
            $scope.footerFollow = !$scope.device.mobile;
        };

        let resizeTimeout = 0;
        window.addEventListener('resize', function () {
            resizeTimeout && clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function(){
                $scope.device = $device.run();
                footerModules();
                $scope.dating.init();
                $scope.$apply();
            }, 250);
        }, { passive: true });

        window.addEventListener("orientationchange", function() {
            resizeTimeout && clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function(){
                $scope.device = $device.run();
                footerModules();
                $scope.dating.init();
                $scope.$apply();
            }, 250);
        }, { passive: true });

        $scope.device = $device.run();
        footerModules();

        /**
         * Video listing sidebar
         */
        if ( $scope.device.mobile === false ) {
            $scope.vp_filters = true;
        }

        if ( $scope.device.mobile === false && window.location.pathname.startsWith('/videos')) {
            if ( window.location.search.length ) {
                const searchParams = new URLSearchParams(window.location.search);
                if ( searchParams.has("onlyPremium") || searchParams.has("d1") || searchParams.has("d2")) {
                    $scope.vp_filters = true;
                }
            }
            if ( window.location.pathname !== '/videos' ) {
                $scope.vp_filters = true;
            }
        }

    /**
     * @property service
         * @type {{ready: boolean}}
         */
        $scope.service = {
            ready: false,
        };

            // Default service params
            let serviceParams = {
             //   blocked: ( $scope.blocked ? 1 : 0 ),
                device: $scope.device.label,
                height: window.screen.availHeight,
                width: window.screen.availWidth,
            };
            // Banners data we need to send to the service
            if ( window.variables.hasOwnProperty('banners')) {
                angular.forEach(window.variables.banners, function (value, key) {
                    if ( value !== null ) {
                        serviceParams[key] = value;
                    }
                });
            }

            $http.get('/service/index?' + http_build_query(serviceParams)).then(function (response) {
                $objects.merge($scope.service,  response.data.payload);
            });

        $scope.dismissAgeGate = function () {
            $http.get('/service/dismiss?dismiss=age-gate').then(function () {
                $scope.service.age_gate.visible = false;
                // Hide cookie module just in case
                $scope.modules.display.cookies = false;
                // Load banners
                $scope.service.banners.available = $scope.service.banners.discovered;
                // Load Google Analytics and HotJar
                $google.load($scope.service.user.country.code);
                $hotJar.load();

            });
        };

        $scope.dismissPartnerOffer = function () {
            $http.get('/service/dismiss?dismiss=partner-offer').then(function () {
                $scope.service.partner_offer = null;
            });
        };
        $scope.dismissPopBar = function () {
            $http.get('/service/index?dismiss=pop-bar').then(function () {
                $scope.service.pop_bar = null;
            });
        };

        $scope.post = {};
        $scope.loadPostPhoto = function ($item) {
            if (typeof $item !== 'undefined') {
                $scope.post.index = $item.index;
                $scope.service.post.slice = $item.slice;
                $scope.service.photo = $item;
            }
        };

        $scope.hidePostPhoto = function () {
            $scope.service.photo = null;
        };

    /**
     * Cache templates after the page is loaded
     */

    $scope.$watch('service.ready', function (ready) {
        if ( ready === true ) {

            /**
             * Hide banners for premium users on mobile
             */

            // if ( $scope.device.mobile === true  ) {
            //     $scope.service.banners.available = $scope.service.banners.discovered;
            //     if ( $scope.service.banners.visible === false ) {
            //         let advertisements = document.querySelectorAll('[data-advertisement-mobile]');
            //         if ( advertisements.length !== 0) {
            //             angular.forEach( advertisements, function (item) {
            //                 item.remove();
            //             });
            //         }
            //     }
            // }
            /**
             * Delay banners loading on desktop and tablet
             */

            if (  $scope.service.banners.visible === true ) {
                if (!$scope.service.age_gate.visible) {
                    $scope.service.banners.available = $scope.service.banners.discovered;
                }
            }

                // $lazy.run();
             $templateRequest('/views/header/_css/base64_icons.html');
              if ( $scope.device.desktop ) {
                 $templateRequest('/views/header/_css/mega-menu.html');
              }

              if(!$scope.service.age_gate.visible && $scope.service.cookiesModule.optionalCookies) {
                  $google.load($scope.service.user.country.code);
                  $hotJar.load();
              }

              if ( $scope.service.cookiesModule.types ) {
                  $scope.cookie.initiate($scope.service.cookiesModule.types);
              }


            /**
             * These are the new Pop-Under and interstitial scripts
             */

            //
            // let s = document.createElement("script");
            // s.type = "text/javascript";
            // s.async = true;
            // s.src = "https://cdn.twinrdsrv.com/Scripts/infinity.js.aspx?guid=c26ce628-936b-429f-8c4c-0e2344bc8c2b";
            // s.id = "infinity";
            // s.setAttribute("data-guid", "c26ce628-936b-429f-8c4c-0e2344bc8c2b");
            // s.setAttribute("data-version", "async");
            // s.setAttribute("data-abr", "false");
            // let e = document.getElementsByTagName("script")[0];
            // e.parentNode.insertBefore(s, e)

            /**
             * Set a cookie if user interacts with the page ( click or touch )
             */

            if ( $scope.service.user.interaction.active === false ) {
                let handler = ('ontouchstart' in document.documentElement ? "touchstart" : "click");
                let interacted = () => {
                    $http.get('/service/dismiss?dismiss=' + $scope.service.user.interaction.cookie ).then(function () {
                        document.body.removeEventListener(handler, interacted);
                        $scope.service.user.interaction.active = true;
                    });
                };
                document.body.addEventListener(handler, interacted, {passive: true});
            }

            setTimeout(function () {
                const customEvent = document.createEvent('Event');
                customEvent.initEvent('serviceReady', true, false);
                window.dispatchEvent(customEvent);
            }, $scope.service.age_gate ? 150 : 0 );

            /**
             * Before you go pop
             */

            if ( $scope.service.byg && document.referrer && new URL(document.referrer).hostname !== window.location.hostname) {
                history.pushState({}, '');
                window.addEventListener('popstate', function(event) {
                    $scope.modules.show('byg');
                    $scope.$apply();
                }, {passive: true });
            }

        }
    });

    $scope.backToTop = function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    /**
     * This is used for newsletter subscribe in footer
     */

    $scope.newsletter = {
        loading: false,
        message: null,
        email: null,
        subscribe: function () {
            this.loading = true;
            $http.post('/newsletter/subscribe.json', { email: this.email })
                .then(( response ) => {
                    if ( response.data.success ) {
                        this.email = null;
                    }
                    this.success = response.data.success;
                    this.message = response.data.service.message;
                    this.loading = false;
                });
        },

    };

    $scope.channel = {
        loading: false,
        subscribe: async function () {
            if ($scope.service.user.guest === true) {
                $rootScope.showLoginPopup = true;
                return;
            }

            try {
                this.loading = true;

                const params = {
                    [$scope.service.security.csrfToken.name]: $scope.service.security.csrfToken.value,
                    channel_id: $scope.service.channel.id
                };
                const destination = $scope.service.channel.subscribed ? $scope.service.channel.links.unsubscribe : $scope.service.channel.links.subscribe;

                await $http.post(destination, params);

                $scope.service.channel.subscribed = !$scope.service.channel.subscribed;
            } finally {
                this.loading = false;
            }
        },
    };

    $scope.pornstar = {
        loading: false,
        subscribe: async function () {
            if ($scope.service.user.guest === true) {
                $rootScope.showLoginPopup = true;
                return;
            }

            try {
                this.loading = true;

                const params = {
                    [$scope.service.security.csrfToken.name]: $scope.service.security.csrfToken.value,
                    porn_star_id: $scope.service.pornstar.id
                };
                const destination = $scope.service.pornstar.subscribed ? $scope.service.pornstar.links.unsubscribe : $scope.service.pornstar.links.subscribe;

                await $http.post(destination, params);

                $scope.service.pornstar.subscribed = !$scope.service.pornstar.subscribed;
            } finally {
                this.loading = false;
            }
        },
    };

    /**
     * Dismiss homepage banner
     * @type {{dismiss: dismiss}}
     */
    $scope.banner = {
        dismiss: function () {
            $http.get('/service/dismiss?dismiss=banner.header').then(function () {
                $scope.service.banners.available.desktop.header = false;
            });
        }
    };

    $scope.cookie = {
        show: true,
        customize: false,
        accepted: {},
        accept: function () {
            this.post();
        },
        acceptAll: function () {
            this.post(true);
        },
        post: function (all = false) {
            $http.post('/accept-cookies', {
                    all: all,
                    accepted: this.accepted
                })
                .then(( response ) => {
                    if(response.data.service.message) {
                        this.show = false;
                    }
                });
        },
        changed(type) {
            $http.get('/service/dismiss?dismiss=cookie&type=' + type + '&data=' + (this.accepted[type] ? 1 : 0)).then(() => {

            });
        },
        initiate(types) {
            angular.forEach(types, (type, key) => {
                $scope.cookie.accepted[type.value] = type.allowed;
            });
        }
    };

    $scope.pills = {
        prevStatus: false,
        nextStatus: true,
        scrollValue: 0,
        prev: function () {
            this.nextStatus = true;
            this.scrollValue = this.scrollValue + 180;
            if (this.scrollValue >= 0) {
                this.prevStatus = false;
                this.scrollValue = 0;
            }
        },
        next: function () {
            let widthScrollable = document.getElementById('-pc-scrollable').offsetWidth;
            let widthFake = document.getElementById('-pc-fake').offsetWidth;
            this.prevStatus = true;
            this.scrollValue = this.scrollValue - 180;
            if (widthFake - widthScrollable <= Math.abs(this.scrollValue)) {
                this.nextStatus = false;
                this.scrollValue = -Math.abs(widthFake - widthScrollable);
            }
        },
    };

    $scope.dating = {
        init: function () {
            this.iframe = 'https://as.sexad.net/as/if?p=reseller&w=1&h=1&v=5104&adHeight=250&adWidth=' + this.width() + '&adType=live&autoplay=false&showvideo=false&hn=porndoe.live&AFNO=1-25915';
        },
        width: function () {
            switch ( true ) {
                case $scope.device.width < 600: return 300;
                case $scope.device.width < 900: return 600;
                case $scope.device.width < 1200: return 900;
                default: return 1200;
            }
        },
        iframe: null,
    };
    $scope.dating.init();


    $scope.signup = {
        password: null,
        passwordStrengthCheck() {
            const password = this.password.toLowerCase();
            let strengthReduction = 0;

            const forbiddenKeywords = ['porn', 'doe', 'test', 'password', 'pass', 'word'];

            // Check password for forbidden keywords
            if (forbiddenKeywords.some(keyword => password.includes(keyword))) {
                strengthReduction += 2;
            }

            // Check for ordered sequences of letters or numbers
            if (this.containsOrderedSequence(password)) {
                strengthReduction += 1;
            }

            // Evaluate the password with the zxcvbn library. It returns a score between 0 and 4
            const result = zxcvbn(this.password);
            // Our additional checks can only influence a password strength for small to medium password lengths
            if (this.password.length < 8) {
                strengthReduction = Math.max(strengthReduction, 2)
            } else if (this.password.length < 12) {
                strengthReduction = Math.max(strengthReduction, 1)
            } else if (this.password.length < 16) {
                strengthReduction = 0
            }
            let passwordScore = result.score - strengthReduction;

            // Normalize the score
            passwordScore = Math.max(passwordScore, 0);

            this.updatePasswordStrengthMessage(passwordScore);
        },
        updatePasswordStrengthMessage(score) {
            const strengthLevels = ['weak', 'fair', 'good', 'strong', 'very strong'];
            const colorMap = {
                weak: "#ff5454",
                fair: "#f1af42",
                good: "#dcbd3e",
                strong: "#a9dc26",
                'very strong': "#17c92b"
            };
            const passwordStrengthContainer = document.getElementById('password_strength_container');
            const message = `Password Strength: <span id="password_strength" style="color: ${colorMap[strengthLevels[score]]}">${strengthLevels[score]}</span>`;
            passwordStrengthContainer.innerHTML = message;

        },
        containsOrderedSequence(password) {
            const alphabet = 'abcdefghijklmnopqrstuvwxyz';
            const numbers = '0123456789';

            for (let i = 0; i < alphabet.length - 2; i++) {
                const sequence = alphabet.slice(i, i + 3);
                if (password.includes(sequence) || password.includes(sequence.split('').reverse().join(''))) {
                    return true;
                }
            }

            for (let i = 0; i < numbers.length - 2; i++) {
                const sequence = numbers.slice(i, i + 3);
                if (password.includes(sequence) || password.includes(sequence.split('').reverse().join(''))) {
                    return true;
                }
            }

            return false;
        }
    }
}];

export default Controller;
